/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ObservableItemActionTypeResponse
 */
export interface ObservableItemActionTypeResponse {
    /**
     * 
     * @type {number}
     * @memberof ObservableItemActionTypeResponse
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof ObservableItemActionTypeResponse
     */
    observableItemId?: number;
    /**
     * 
     * @type {number}
     * @memberof ObservableItemActionTypeResponse
     */
    actionTypeId?: number;
    /**
     * 
     * @type {string}
     * @memberof ObservableItemActionTypeResponse
     */
    triggerValue?: string;
}

/**
 * Check if a given object implements the ObservableItemActionTypeResponse interface.
 */
export function instanceOfObservableItemActionTypeResponse(value: object): value is ObservableItemActionTypeResponse {
    return true;
}

export function ObservableItemActionTypeResponseFromJSON(json: any): ObservableItemActionTypeResponse {
    return ObservableItemActionTypeResponseFromJSONTyped(json, false);
}

export function ObservableItemActionTypeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ObservableItemActionTypeResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'observableItemId': json['observableItemId'] == null ? undefined : json['observableItemId'],
        'actionTypeId': json['actionTypeId'] == null ? undefined : json['actionTypeId'],
        'triggerValue': json['triggerValue'] == null ? undefined : json['triggerValue'],
    };
}

export function ObservableItemActionTypeResponseToJSON(json: any): ObservableItemActionTypeResponse {
    return ObservableItemActionTypeResponseToJSONTyped(json, false);
}

export function ObservableItemActionTypeResponseToJSONTyped(value?: ObservableItemActionTypeResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'observableItemId': value['observableItemId'],
        'actionTypeId': value['actionTypeId'],
        'triggerValue': value['triggerValue'],
    };
}

